module.exports = __webpack_public_path__ + "static/media/icon-medidor-purple.3c96962e.svg";